export default __webpack_public_path__ + "static/media/python.da503bdc.png";